import React, { useEffect, useMemo } from 'react';
import BroadcastCard from '../Components/BroadcastCard';
import { registerServiceWorker, ensureNotificationPermission, subscribePush, sendSubscriptionToServer } from '../utils/push';

// A minimal page that only renders the BroadcastCard overlay.
// Useful for streamers and for OBS Browser Source / Window Capture.
export default function BroadcastOverlay() {
  const { token, userEmail } = useMemo(() => {
    try {
      const t = localStorage.getItem('token');
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      const email = u?.emailId || u?.email || '';
      return { token: t, userEmail: email };
    } catch {
      return { token: null, userEmail: '' };
    }
  }, []);

  // Register SW + subscribe to push so OS notifications can alert with sound in background
  useEffect(() => {
    (async () => {
      try {
        const reg = await registerServiceWorker();
        if (!reg) return;
        const granted = await ensureNotificationPermission();
        if (!granted) return;
        const sub = await subscribePush(reg);
        if (!sub) return;
        await sendSubscriptionToServer(sub, token, userEmail);
      } catch (e) {
        console.warn('Overlay push setup failed', e);
      }
    })();
  }, [token, userEmail]);

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      background: '#00ff00',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {/* Always render BroadcastCard so it can use public fallback when not logged in */}
      <div style={{ position: 'relative' }}>
        <BroadcastCard userEmail={userEmail} token={token} standalone={true} />
      </div>
    </div>
  );
}
